/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './index.module.css';

export default function NavButton({
  children,
  selected,
  onClick,
  ...props
}) {
  return (
    <button
      onClick={onClick}
      type="button"
      className={classNames(
        Styles.mainContainer,
        { [Styles.mainContainerSelected]: selected },
      )}
      {...props}
    >
      {children}
    </button>
  );
}

NavButton.propTypes = {
  children: PropTypes.node,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};

NavButton.defaultProps = {
  children: null,
  selected: false,
  onClick: () => {},
};
